import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import { setupRouterGuard } from './router/guard.js';
import App from './App.vue';
import router from './router';
import 'ant-design-vue/dist/reset.css';
import 'vditor/dist/index.css';
// import 'ant-design-vue/dist/antd.css';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

// 设置 dayjs 语言
dayjs.locale('zh-cn');

// 创建 vue 实例
const app = createApp(App);

// 创建 pinia 实例
const pinia = createPinia();

// 使用持久化插件
pinia.use(createPersistedState());

// 先注册 pinia
app.use(pinia);

// 再注册路由
app.use(router);

// 最后设置路由守卫
setupRouterGuard(router);

// 提供全局语言配置
app.provide('antLocale', zhCN);

app.mount('#app');